import React from 'react'
import styled from 'styled-components'
// import { Parallax } from 'react-parallax'
import { useStaticQuery, graphql } from 'gatsby'

export default ({title, none_rhapsodist, category, CategoryStyled, children}) => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "main_image_0_1.png" }) {
        childImageSharp{
          fluid {
            src
          }
        }
      }
    }
  `)
  return (
    <Container>
      <TopTextBox>
        {none_rhapsodist ? 
          <CategoryStyled>
            {category}
          </CategoryStyled> : 
          <SignatureText>Rhapsodist</SignatureText>
        }
        <TopText none_rhapsodist={none_rhapsodist}>
          {title}
        </TopText>
        { children ? children : null}
      </TopTextBox>
      {/* <Parallax
        blur={0}
        bgImage={data?.file?.childImageSharp?.fluid?.src}
        bgImageAlt="test"
        strength={200}
      > */}
        <SubImage img={data?.file?.childImageSharp?.fluid?.src}/>
      {/* </Parallax> */}
    </Container>
  )
}

const Container = styled.div`
  height: auto;
  background-color: ${props => props.theme.green};
  overflow-y: hidden;
  @media(min-width: 900px) {
    width: 100%;
    height: 80vh;
  }
`
const TopTextBox = styled.div`
  position: absolute;
  top: 9rem;
  left: 2rem;
  z-index: 100;
  @media(min-width: 900px) {
    top: 13rem;
    /* left: 12rem; */
    top: 15%;
    left: 10%;
  }
`
const TopText = styled.h1`
  font-size: 2rem;
  font-family: ELEPHNT;
  color: #fff;
  font-weight: 100;
  letter-spacing: 0.2rem;
  max-width: 98%;
  @media(min-width: 900px) {
    font-size: 5.3rem;
  }
`
const SignatureText = styled(TopText)`
  font-size: 2.5rem;
  @media(min-width: 900px) {
    font-size: 6rem;
  }
`
const SubImage = styled.div`
  width: 100%;
  height: 25rem;
  background-image: url('${props => props.img}');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  z-index: -1;
  @media(min-width: 900px) {
    height: 80vh;
    width: 100%;
    margin: 0 auto;
  }
`